const product = [
  {
    name: '520x',
    src: require("@/assets/images/product1.png"),
  },
]

export default product